import React from "react";
import { TwilioDeviceProvider } from "./TwilioDeviceContext";
import CallWidget from "./CallWidget";

/**
 * Global call widget wrapper that provides Twilio device context
 * and renders the floating call widget UI.
 * Mount this at the layout level (app.tsx childrenRender).
 */
const CallWidgetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <TwilioDeviceProvider>
      {children}
      <CallWidget />
    </TwilioDeviceProvider>
  );
};

export default CallWidgetProvider;
export { useTwilioDevice, TwilioDeviceProvider } from "./TwilioDeviceContext";
export { default as CallWidget } from "./CallWidget";
